<mat-sidenav-container class="inset-0">
	<mat-sidenav *ngIf="currentUser$ | async" #sidenav [mode]="isMobile ? 'over' : 'side'" [opened]="!isMobile">
		<app-sidebar></app-sidebar>
	</mat-sidenav>
	<mat-sidenav-content>
		<app-header *ngIf="currentUser$ | async as user" (toggleSidenavRequested)="toggleSidenav()" (logoutRequested)="onLogout()" [isMobile]="isMobile" [currentUser]="user"></app-header>
		<main [style.padding.px]="(currentUser$ | async) ? 24 : 0">
			<router-outlet />
		</main>
	</mat-sidenav-content>
</mat-sidenav-container>
<app-loader></app-loader>